export default __webpack_public_path__ + "static/media/single-project-page-03-img03.5e27e745.jpg";